import React from 'react'

import ButtonStandard from '@/component/Primitive/ButtonStandard'
import Icon from '@/component/Primitive/Icon'
import Inline from '@/component/Primitive/Inline'
import Prose from '@/component/Primitive/Prose'
import Spacer from '@/component/Primitive/Spacer'
import Stack from '@/component/Primitive/Stack'
import Type from '@/component/Primitive/Type'

const Sidebar = () => (
  <Stack gap="m">
    <Type as="h2" size="xl" bold>
      Welcome to the Citygate Portal
    </Type>
    <Prose inverse>
      <p>
        Create your Citygate account to save your favourite vehicles and more.
        We are continuously improving our site and working on lots of exciting
        new features for you including online vehicle valuations and more,
        coming very soon.
      </p>
    </Prose>
    <Inline align="center">
      <Type bold>Already have an account?</Type>
      <Spacer style={{ transform: 'translateY(1px)' }}>
        <ButtonStandard to="/auth/login" outline inverse shrink>
          <Icon type="person" a11yText="" width={16} /> Log in
        </ButtonStandard>
      </Spacer>
    </Inline>
  </Stack>
)

export default Sidebar
